import { Routes, Route } from "react-router-dom";
import KioskTabs from "./components/KioskTabs";
import Dashboard from "./routes/Dashboard";
import ChangelogDashboard from "./routes/Changelog/ChangelogDashboard";
import PDP from "./routes/PDP";
import {
  NikeDesignSystemProvider,
  useTokens,
} from "@nike/nike-design-system-components";
import { RequireAuth } from "./auth";

const App = () => {
  const tokens = useTokens();
  return (
    <NikeDesignSystemProvider lang="en-us" themeExtension={tokens}>
      <RequireAuth>
        <Routes>
          <Route path="/" element={<KioskTabs />}>
            <Route index element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="changelog/:id?" element={<ChangelogDashboard />} />
            <Route path="pdp-v3" element={<PDP />} />
          </Route>
        </Routes>
      </RequireAuth>
    </NikeDesignSystemProvider>
  );
};

export default App;
